<div class="top">
  <div class="left">
    <div class="title">
      <div class="top">{{ assessmentSubTypeLabels[item.subType] }}</div>
      <div class="bottom">{{ item.dateIso | date: 'fullDate' }}, {{ item.dateIso | date: 'shortTime' }}</div>
    </div>
    <div class="score">
      <div class="hand">L: {{ item.score_left }}</div>
      <div class="hand">R: {{ item.score_left }}</div>
    </div>
  </div>
  <div class="right">
    {{ item.note }}
    <!-- <p>{{ item.history | json}}</p> -->
  </div>
</div>
